import { Text } from "@chakra-ui/react";

export const SalesCannotCloseEmptySaleError = () => {
  return <Text>Vous ne pouvez pas clôturer une vente vide.</Text>;
};
